import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { comics } from '@/mocks/comics';

export default function LatestPage() {
  const [filter, setFilter] = useState<'all' | 'today' | 'week'>('all');

  useEffect(() => {
    document.title = '最新更新 - 韩国漫画每日更新 - 韩国漫画网';
  }, []);

  const sorted = [...comics].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-20 pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-700 font-medium">最新更新</span>
          </nav>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">最新更新</h1>
            <div className="flex items-center gap-1 bg-background-100 rounded-full p-1">
              {(['all', 'today', 'week'] as const).map((f) => (
                <button
                  key={f}
                  onClick={() => setFilter(f)}
                  className={`px-4 py-2 rounded-full text-xs font-label cursor-pointer transition-colors whitespace-nowrap ${
                    filter === f ? 'bg-background-50 text-foreground-950 font-medium' : 'text-foreground-500 hover:text-foreground-700'
                  }`}
                >
                  {f === 'all' && '全部'}
                  {f === 'today' && '今日更新'}
                  {f === 'week' && '本周更新'}
                </button>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5" data-product-shop="">
            {sorted.map((comic) => (
              <Link key={comic.id} to={`/comic/${comic.id}`} className="group cursor-pointer">
                <div className="relative rounded-xl overflow-hidden aspect-[3/4] mb-3">
                  <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                  <div className="absolute bottom-2 left-2">
                    <span className="text-xs text-white/80 font-label">更新至{comic.chapters}话</span>
                  </div>
                </div>
                <h3 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">{comic.title}</h3>
                <p className="text-xs text-foreground-500">{comic.updateTime}</p>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}